import { render } from "./MmForgotPassword.vue?vue&type=template&id=6576145e"
import script from "./MmForgotPassword.vue?vue&type=script&lang=js"
export * from "./MmForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__